var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84945 23.8709H26.5111V5.20426H4.84945V23.8709ZM27.3194 25.5376H4.04118C3.59469 25.5376 3.23291 25.1646 3.23291 24.7043V4.37093C3.23291 3.9106 3.59469 3.5376 4.04118 3.5376H27.3194C27.7659 3.5376 28.1276 3.9106 28.1276 4.37093V24.7043C28.1276 25.1646 27.7659 25.5376 27.3194 25.5376Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.808271 22.2041C0.361782 22.2041 0 21.8311 0 21.3708V1.03743C0 0.577102 0.361782 0.204102 0.808271 0.204102H24.0865C24.533 0.204102 24.8947 0.577102 24.8947 1.03743C24.8947 1.49777 24.533 1.87077 24.0865 1.87077H1.61654V21.3708C1.61654 21.8311 1.25476 22.2041 0.808271 22.2041Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.5375f6656fbe5618be68b25f86105d94.svg";
export { ForwardRef as ReactComponent };